// @flow
import { filter, get } from "lodash";
import type {
  PastRaceBettingInterests,
  RaceCardBettingInterest
} from "@tvg/types/Race";
import type { PastPerformanceRace } from "@fdr/types/PastPerformance";

const convertBettingInterests = (
  bettingInterests: PastRaceBettingInterests[]
): {
  bettingInterests: RaceCardBettingInterest[],
  scratchedRunners: string[]
} => {
  const scratchedRunners = [];
  const bettingInterestsFormated = bettingInterests.map((betInterest) => ({
    biNumber: betInterest.biNumber,
    currentOdds: betInterest.currentOdds || {
      numerator: 0,
      denominator: 0
    },
    morningLineOdds: betInterest.morningLineOdds || {
      numerator: 0,
      denominator: 0
    },
    isFavorite: betInterest.favorite,
    runners: betInterest.runners.map((runner) => {
      if (runner.scratched) {
        scratchedRunners.push(runner.runnerId);
      }

      return {
        horseName: runner.horseName,
        dob: get(runner, "dob"),
        runnerId: runner.runnerId,
        scratched: runner.scratched,
        handicapping: [runner.jockey, runner.trainer],
        masterPickNumber: -1,
        jockey: runner.jockey,
        trainer: runner.trainer
      };
    })
  }));

  return {
    bettingInterests: bettingInterestsFormated,
    scratchedRunners
  };
};

export const getFilteredRaces = (
  races: PastPerformanceRace[],
  conditionsToMatch: {
    distance: ?string,
    surface: ?string
  }
): { races: PastPerformanceRace[], ids: string[] } => {
  const ids = [];

  return {
    races: filter(races, (race: PastPerformanceRace) => {
      if (
        race.distance === conditionsToMatch.distance &&
        race.surface.shortName === conditionsToMatch.surface
      ) {
        ids.push(race.id);
        return true;
      }
      return false;
    }),
    ids
  };
};

export default convertBettingInterests;
